import React from "react";
import SupervisorApi from "../../utility/supervisorApi";
import { useQuery } from "@tanstack/react-query";
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";

function TopSellingProducts({ currencyDetails }) {
  const { fetchOnlyData } = SupervisorApi();

  const { data, isLoading } = useQuery({
    queryKey: ["topProducts"],
    queryFn: () => fetchOnlyData("dashboard/topSelling-product"),
  });

  console.log(data);
  return (
    <div className="mb-6 overflow-x-auto">
      <h3 className="text-3xl font-semibold mb-2">Top Selling Products</h3>
      {/* Product Cards */}
      <div className="grid grid-cols-5 gap-4">
        {data?.data?.map((item) => (
          <div key={item?.id} className="border p-2 rounded-md text-center">
            <ImageWithPlaceholder
              item={item}
              className="w-24 mx-auto rounded-md"
              placeholderClassName=" w-[80%] mx-auto flex justify-center items-center text-4xl bg-gray-200 px-2 py-4 font-semibold  rounded-md"
            />
            {item?.product_name}
            <br />
            {currencyDetails}
            {item?.price}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TopSellingProducts;
